import { useEffect } from 'react';
import { trackPage } from './trackPage';

export const useTrackPage = (pagePath: string) => {
    useEffect(() => {
        const controller = new AbortController();
        trackPage(pagePath, {}, null, controller.signal);
        return () => {
            controller.abort();
        };
    }, [pagePath]);
};
